var BaseReconnect = /** @class */ (function () {
    function BaseReconnect(signalClientService) {
        this.signalClientService = signalClientService;
        this.reconnectFunc = this.onReconnected.bind(this);
    }
    BaseReconnect.prototype.attached = function () {
        this.signalClientService.onReconnected(this.reconnectFunc);
    };
    BaseReconnect.prototype.detached = function () {
        this.signalClientService.offReconnected(this.reconnectFunc);
    };
    return BaseReconnect;
}());
export { BaseReconnect };
